import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c2d5918")

_pushScopeId("data-v-3c2d5918")
const _hoisted_1 = { class: "ui__waterCheck_main" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_defectList = _resolveComponent("defectList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.defectList.length > 0)
      ? (_openBlock(), _createBlock(_component_defectList, {
          key: 0,
          defectData: _ctx.state
        }, null, 8, ["defectData"]))
      : _createCommentVNode("", true)
  ]))
})